<template>
	<section class="ResetPassword_Form grid-container">
		<form
			id="ResetPassword_Form"
			name="ResetPassword_Form"
			@submit.prevent="passwordResetSubmit"
		>
			<div class="grid-x grid-margin-y">
				<div class="cell">
					<h1 class="h2 ResetPassword_Form__title">
						{{ $t('resetpassword.titleText') }}
					</h1>
				</div>
				<div
					class="cell small-10 small-offset-1 medium-6 medium-offset-3 large-6 large-offset-3 gutter-top"
				>
					<InputComponent
						:placeholderValue="$t('login.emailPlaceholder')"
						v-model="email"
						:hasError="erorr"
						:errorMessage="errorMessage"
						:whiteErrorColor="true"
					></InputComponent>
				</div>
				<div
					class="cell small-10 small-offset-1 medium-6 medium-offset-3 large-6 large-offset-3"
					v-if="passwordSent == false"
				>
					<p class="colorWhite ResetPassword_Form__text">
						{{ $t('resetpassword.descriptionText') }}
					</p>
				</div>
				<div class="cell" v-if="passwordSent">
					<p class="colorWhite ResetPassword_Form__text">
						{{ $t('resetpassword.passwordSentText') }}
					</p>
					<br />
				</div>
				<div
					class="cell small-6 small-offset-3 medium-6 medium-offset-3 large-6 large-offset-3 gutter-top"
					v-if="!passwordSent"
				>
					<Button submit full :loading="loading">
						{{ $t('resetpassword.passwordSendButton') }}
					</Button>
				</div>
				<div v-if="passwordSent == false" class="cell">
					<router-link class="white underline back" :to="{ name: 'login' }">
						{{ $t('resetpassword.orLoginLink') }}
					</router-link>
				</div>
				<div v-else class="cell">
					<router-link class="white underline back" :to="{ name: 'login' }">
						{{ $t('resetpassword.loginLink') }}
					</router-link>
				</div>
			</div>
		</form>
	</section>
</template>

<script>
import Button from '../../../components/atoms/Button'
import InputComponent from '../../../components/atoms/InputComponent'
import store from '../../../vueX/store'

export default {
	name: 'ResetPassword_Form',
	components: {
		InputComponent,
		Button
	},
	data: () => {
		return {
			email: '',
			loading: false,
			passwordSent: false,
			erorr: false,
			errorMessage: ''
		}
	},
	methods: {
		passwordResetSubmit() {
			if (this.email) {
				this.loading = true
				this.errorMessage = ''
				this.error = false
				store.dispatch('POST_RESET_PASSWORD', this.email).then(success => {
					this.loading = false
					if (success) {
						this.passwordSent = true
					} else {
						this.erorr = true
						this.errorMessage = this.$t('edit.emailAddressNotFound')
					}
				})
			} else {
				this.errorMessage = this.$t('edit.missingEmailAddress')
				this.erorr = true
			}
		}
	},
	created() {}
}
</script>

<style scoped lang="scss">
.ResetPassword_Form {
	&__title {
		color: white;
		text-align: center;
	}

	&__text {
		margin: 0 10px;
	}

	.gutter-top {
		margin-top: 50px;
	}
}
</style>
